import React, { useState, useEffect, useContext } from "react";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import EsimsHorizontalScroll from "../../components/Esim/EsimsHorizontalScroll/EsimsHorizontalScroll";
import EsimActionsSection from "../../components/Esim/EsimActionsSection/EsimActionsSection";
import EmptyEsimView from "../../components/Esim/EmptyEsimView/EmptyEsimView";
import { fetchUserEsims } from "../../services/EsimService";
import { useNavigate } from "react-router-dom";
import "./Esim.css";

const EsimScreen = () => {
  const [esims, setEsims] = useState([]);
  const [selectedEsim, setSelectedEsim] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserEsims()
      .then((data) => {
        setEsims(data.items || []);
        setLoading(false);
        if (data.items && data.items.length > 0) {
          setSelectedEsim(data.items[0]);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="loading">Loading your eSIMs...</div>;
  const hasEsims = esims && esims.length > 0;

  return (
    <div className="esim-screen">
      {hasEsims ? (
        <>
          <PageHeader title="My eSIM" description="Install, top-up and manage all your eSIM profiles in one place" />
          <EsimsHorizontalScroll esims={esims} selectedEsim={selectedEsim} onSelectedEsimChange={setSelectedEsim} />
          <EsimActionsSection selectedEsim={selectedEsim} />
        </>
      ) : (
        <EmptyEsimView />
      )}
    </div>
  );
};

export default EsimScreen;
